export function replaceHash(hashValue: string) {
  const hash = hashValue ? `#${hashValue}` : '';
  history.replaceState({}, '', `${location.pathname}${hash}`);
}
